import(/* webpackMode: "eager" */ "/home/runner/work/sixsense-website-v2/sixsense-website-v2/src/app/about/page.tsx");
